import { createFileRoute } from '@tanstack/react-router'
import { WeekdayCredentials } from '@/features/admin/weekday-credentials'

export const Route = createFileRoute(
  '/_authenticated/admin/weekday-credentials'
)({
  component: WeekdayCredentials,
})
